import React, { type CSSProperties } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import bpBanner from '../assets/bp_banner_large.png';
import colors from '../constants/colors';
import { registerMaintenanceBypassTap } from '../utils/maintenanceBypass';

type MaintenanceModalProps = {
  show: boolean;
  onRetry: () => void;
  retrying?: boolean;
};

const i18nPrefix = 'MaintenanceModal';

const MaintenanceModal = ({
  show,
  onRetry,
  retrying = false,
}: MaintenanceModalProps) => {
  const { t } = useTranslation();

  const handleLogoPress = () => {
    registerMaintenanceBypassTap();
  };

  return (
    <Modal
      centered
      show={show}
      backdrop='static'
      keyboard={false}
      animation={false}>
      <Modal.Body style={styles.body}>
        <button
          type='button'
          style={styles.logoButton}
          onClick={handleLogoPress}
          aria-label='Boatpark'>
          <img src={bpBanner} alt='Boatpark' style={styles.logoImage} />
        </button>

        <h5 style={styles.title}>
          {t(`${i18nPrefix}.title`, {
            defaultValue: 'Maintenance in progress',
          })}
        </h5>

        <p style={styles.text}>
          {t(`${i18nPrefix}.text`, {
            defaultValue:
              'Boatpark is temporarily unavailable due to scheduled maintenance. Please try again later.',
          })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onRetry} disabled={retrying}>
          {t('global.ok')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const styles: { [key: string]: CSSProperties } = {
  body: {
    textAlign: 'center',
  },
  logoButton: {
    background: 'transparent',
    border: 'none',
    cursor: 'default',
    margin: '0 auto 16px',
    padding: 0,
  },
  logoImage: {
    display: 'block',
    height: 'auto',
    maxWidth: 220,
    width: '100%',
  },
  title: {
    color: colors.MAIN_RED,
    fontWeight: 700,
    marginBottom: 12,
  },
  text: {
    margin: 0,
  },
};

export default MaintenanceModal;
